import { useState } from 'react';
import { useMutation } from 'react-apollo';

import useAccount from '../../hooks/useAccount';
import { accountDelete as accountDeleteMutation } from '../../../../graphql/mutations/account';
import useOpenAlert from '../../../../hooks/useOpenAlert';
import { getErrorString } from '../../../../util/normalize-errors';

const useAccountDelete = ({ onSuccess }) => {
  const [deleting, setDeleting] = useState(false);
  const { account } = useAccount();
  const openAlert = useOpenAlert();

  const [accountDelete] = useMutation(accountDeleteMutation);

  const onAccountDelete = async () => {
    if (deleting) {
      return;
    }

    setDeleting(true);
    try {
      await accountDelete({
        variables: {
          input: {
            account_id: account.id,
          },
        },
      });
      onSuccess?.();
    } catch (e) {
      openAlert({
        type: 'error',
        message: getErrorString(e),
      });
    }
  };

  return {
    account,
    onAccountDelete,
  };
};

export default useAccountDelete;
